// extracted by mini-css-extract-plugin
export default {"label":"OptionsSelect_label__K85Lf","floating-label":"OptionsSelect_floating-label__oL7uY","chevrondown-icon":"OptionsSelect_chevrondown-icon__pk-X6"};